/** Thanh HUD trên cùng: tiền, ngày/giờ game, cấp, danh tiếng, tốc độ. */
import { gioTrongNgay } from '../../core/khach.js';
import { capHienTai } from '../../core/cua-hang.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, useCapNhat, xpCanChoCap } from '../dung-chung.js';

export function Hud(props: {
  controller: GameController;
  soKhach: number;
  datTocDo: (t: number) => void;
}) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu, caiDat } = controller;

  const ngay = Math.floor(state.tongGioGame / 24) + 1;
  const gio = gioTrongNgay(state.tongGioGame);
  const cap = capHienTai(state, duLieu);

  const xpHienTai = xpCanChoCap(state.nguoiChoi.cap);
  const xpTiep = xpCanChoCap(state.nguoiChoi.cap + 1);
  const tienDoXp =
    xpTiep > xpHienTai ? Math.min(1, (state.nguoiChoi.xp - xpHienTai) / (xpTiep - xpHienTai)) : 1;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        padding: '8px 12px',
        background: 'rgba(20, 14, 8, 0.85)',
        color: '#f5e9d0',
        fontSize: '14px',
        zIndex: 10,
        flexWrap: 'wrap',
      }}
    >
      <strong style={{ fontSize: '16px' }}>💰 {dinhDangXu(state.xu)}</strong>
      <span>
        📅 Ngày {ngay} — {String(gio).padStart(2, '0')}:00
      </span>
      <span>🏪 {cap.ten}</span>
      <span title="Cấp người chơi">
        ⭐ Cấp {state.nguoiChoi.cap}
        <span
          style={{
            display: 'inline-block',
            width: '60px',
            height: '8px',
            background: '#4a3a22',
            borderRadius: '4px',
            marginLeft: '4px',
            verticalAlign: 'middle',
          }}
        >
          <span
            style={{
              display: 'block',
              height: '100%',
              width: `${Math.round(tienDoXp * 100)}%`,
              background: '#7fe07f',
              borderRadius: '4px',
            }}
          />
        </span>
      </span>
      <span title="Danh tiếng ảnh hưởng lượng khách">😊 {state.danhTieng.toFixed(2)}</span>
      <span title="Khách đang trong cửa hàng (hình ảnh)">🚶 {props.soKhach}</span>
      <span style={{ marginLeft: 'auto', display: 'flex', gap: '4px', alignItems: 'center' }}>
        Tốc độ:
        {[1, 2, 8].map((t) => (
          <button
            key={t}
            onClick={() => props.datTocDo(t)}
            style={{
              background: caiDat.tocDo === t ? '#c98a2e' : 'transparent',
              color: caiDat.tocDo === t ? '#1d130a' : '#f5e9d0',
              border: '1px solid #8a6a3a',
              borderRadius: '6px',
              padding: '4px 10px',
              cursor: 'pointer',
              fontWeight: caiDat.tocDo === t ? 700 : 400,
            }}
          >
            {t}×
          </button>
        ))}
      </span>
    </div>
  );
}
